/* unplugin-vue-components disabled */import { render } from "./partyStatistics.vue?vue&type=template&id=04239edc&scoped=true&ts=true"
import script from "./partyStatistics.vue?vue&type=script&lang=ts"
export * from "./partyStatistics.vue?vue&type=script&lang=ts"

import "./partyStatistics.vue?vue&type=style&index=0&id=04239edc&lang=scss&scoped=true"

import exportComponent from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04239edc"]])

export default __exports__